import { Stack } from "@mui/material";

import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import VehicleOperations from "@/common/components/EntityComposed/Operations/VehicleOperations";
import { ViewVariant } from "@/common/ts/layout";
import { ContractDto } from "@/core/api/generated/v1";

interface Props {
  contract: ContractDto;
}

export default function OperationsTabContent({ contract }: Props) {
  return (
    <PageTabContent>
      <Stack direction='column' spacing={2}>
        <VehicleOperations
          displayProps={{
            viewVariant: ViewVariant.Tab,
            header: false,
          }}
          vehicleId={contract.vehicle?.id}
          contractId={contract.id}
        />
      </Stack>
    </PageTabContent>
  );
}
